var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 5.16669L6.77531 8.97698C7.21609 9.28553 7.43648 9.4398 7.67621 9.49956C7.88796 9.55234 8.10943 9.55234 8.32119 9.49956C8.56091 9.4398 8.7813 9.28553 9.22208 8.97698L14.6654 5.16669M4.53203 13.8334H11.4654C12.5855 13.8334 13.1455 13.8334 13.5733 13.6154C13.9497 13.4236 14.2556 13.1177 14.4474 12.7413C14.6654 12.3135 14.6654 11.7535 14.6654 10.6334V6.36669C14.6654 5.24658 14.6654 4.68653 14.4474 4.25871C14.2556 3.88238 13.9497 3.57642 13.5733 3.38467C13.1455 3.16669 12.5855 3.16669 11.4654 3.16669H4.53203C3.41193 3.16669 2.85187 3.16669 2.42405 3.38467C2.04773 3.57642 1.74176 3.88238 1.55002 4.25871C1.33203 4.68653 1.33203 5.24658 1.33203 6.36669V10.6334C1.33203 11.7535 1.33203 12.3135 1.55002 12.7413C1.74176 13.1177 2.04773 13.4236 2.42405 13.6154C2.85187 13.8334 3.41193 13.8334 4.53203 13.8334Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlIcon);
export default __webpack_public_path__ + "static/media/url-icon.838e254314dde5f6871d4a75afe8b7b6.svg";
export { ForwardRef as ReactComponent };